import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { InputBase } from '@mui/material';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import {
	SetFormState, DeleteIncident, ToggleDeleteIncidentTrackerDialog, GetIncidents
} from '../../../actions/IncidentTrackerActions';

const IncidentTrackerDeleteDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.incidentTrackerDemoReducer.tableId);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const _onConfirmClick = () => {
		dispatch(DeleteIncident(userId, tableId));
		dispatch(ToggleDeleteIncidentTrackerDialog(false));
		dispatch(GetIncidents(userId, role));
		dispatch(enqueueSnackbar({ message: 'Incident deleted', options: { variant: 'info' } }));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Delete incident"
			confirmLabel="Ok"
			onConfirmClicked={_onConfirmClick}
		>
			<InputBase
				// className={classes.margin}
				defaultValue="Do you want to delete this incident?"
				inputProps={{ 'aria-label': 'naked' }}
				fullWidth
			/>
		</ModalDialog>
	);
};

IncidentTrackerDeleteDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default IncidentTrackerDeleteDialog;
